import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import { useContext } from '../Context';
import CreateModal from './CreateModal';
import Table from './Table';

export default function Index() {
  const { dispatch, actions, state } = useContext();
  const [showCreate, setShowCreate] = useState(false);

  return (
    <>
      {state.viewMode == 'view' && (
        <div className="ibox-content mt20">
          <h1>Documents</h1>
          <div className="text-right">
            <Button
              onClick={() => setShowCreate(true)}
              bsClass="btn btn-green width-120"
            >
              Add File
            </Button>
          </div>
          <Table />
          <CreateModal show={showCreate} onHide={() => setShowCreate(false)} />
        </div>
      )}
    </>
  );
}
